import _Watermark from './Watermark';

import './style/index.js';

export type { WatermarkProps } from './Watermark';

export * from './type';

export const Watermark = _Watermark;
export default Watermark;
